import React, { useState, useEffect } from 'react';
import './Timeline.css';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';

const revealFromLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
};

const revealFromRight = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
};

const Timeline = () => {
    const [timelineData, setTimelineData] = useState([]);
    const data = useSelector((state) => state.data.data);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        if (data && data.timeline) {
            const sortedData = [...data.timeline].sort((a, b) => new Date(b.starting) - new Date(a.starting));
            // Adding number with leading zero formatting
            const formattedData = sortedData.map((item, index) => ({
                ...item,
                number: (index + 1).toString().padStart(2, '0') // Convert index to 1-based and pad with zero if necessary
            }));
            setTimelineData(formattedData);
        }
    }, [data]);

    const handleToggle = () => {
        setShowAll(!showAll);
    };

    return (
        <div className="experience-section mt-28 mb-24">
            <div style={{ margin: "20px" }} className="leadwork">
                <h1 className='text-center font-semibold text-3xl'>My Career.</h1>
            </div>
            <div className="timeline">
                <div className="elementlineExtension"></div>
                {timelineData.slice(0, showAll ? timelineData.length : 3).map((item, index) => (
                    <div key={item.number} className={`timelineElement ${index % 2 === 0 ? 'even' : 'odd'}`}>
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false }}
                            transition={{ duration: 0.5 }}
                            variants={index % 2 === 0 ? revealFromRight : revealFromLeft}
                            className={`elementcontent ${index % 2 === 0 ? 'even' : 'odd'}`}
                        >
                            <p className="element_lead font-semibold">{`.> ${item.institute}`}</p>
                            <p className="element_id mb-5 font-semibold text-2xl">.{item.number} - {item.role}</p>
                            <p className="element_date">{`// `}{item.starting} - {item.ending}</p>
                        </motion.div>
                        <div className="elementline">
                            <div className="linemain" />
                            <div className="lineball" />
                            <div className="linemain" />
                        </div>
                        <div className="elementblank" />
                    </div>
                ))}
                <div className="elementlineExtension"></div>
            </div>

            <div style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
                <div className='btn' onClick={handleToggle}>
                    <div className='btn_text'>{showAll ? 'Show Less' : 'See More'}</div>
                </div>
            </div>
        </div>
    );
};

export default Timeline;
